import {HttpEvent, HttpHandlerFn, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';

export const LANGUAGE_PARAM_NAME = 'language';

export function removeMarketSpecificLanguage(url: string): string {
    if (!url.includes(LANGUAGE_PARAM_NAME)) return url;
    const dividedUrl = url.split('?');
    const mainRequestPart = dividedUrl[0];
    const argsParts = dividedUrl[1]?.split('&');
    const langIdx = argsParts.findIndex(param => param.split('=')[0] === LANGUAGE_PARAM_NAME);
    if (langIdx !== -1) argsParts[langIdx] = argsParts[langIdx].split('_')[0];
    return mainRequestPart + '?' + argsParts.join('&');
}

export const includeLanguageInterceptor: (req: HttpRequest<unknown>, next: HttpHandlerFn) => Observable<HttpEvent<unknown>>
    = (req, next) => next(req.clone({
    url: removeMarketSpecificLanguage(req.url)
}));

